import React from "react";
import { Link } from "react-router-dom";
import { daysInStageText, leadName } from "../lib/leads";
import { todayISO } from "../../helpers/datetime";
import { Button, Card, Empty } from "../ui";
import { HiddenLabel } from "./Hidden";
import { LeadValue, NextStepLine, StageBadge, StallFlag } from "./LeadParts";

// Open leads on a contact or company detail: each links to the lead, with
// "New lead" and a link to every lead (open and closed) in the Leads list.
export default function LeadsList({ leads, showCompany, onNew, allPath }) {
    const today = todayISO();
    return (
        <Card
            noBody
            title="Open leads"
            actions={onNew && <Button size="sm" variant="soft" icon="ri-add-line" onClick={onNew}>New lead</Button>}
            footer={allPath && <Link to={allPath} className="hz-small">All leads, open and closed <i className="ri-arrow-right-s-line"></i></Link>}
        >
            {(!leads || leads.length === 0) && <Empty small>No open leads.</Empty>}
            {(leads || []).map((l) => (
                <Link key={l.id} to={`/crm/leads/${l.id}`} className="hz-list-item" style={{ alignItems: "flex-start" }}>
                    <i className="ri-funds-line" style={{ fontSize: 16, color: "var(--hz-primary)", marginTop: 2 }}></i>
                    <div className="hz-spacer" style={{ minWidth: 0, display: "grid", gap: 4 }}>
                        <div className="hz-row-wrap" style={{ gap: 6 }}>
                            <span className="hz-strong">{leadName(l)}</span>
                            {showCompany && l.title && <span className="hz-small hz-muted">{l.company_name}</span>}
                            {showCompany && <HiddenLabel at={l.company_hidden_at} />}
                            <StageBadge stage={l.stage} />
                            <StallFlag lead={l} today={today} />
                        </div>
                        <NextStepLine lead={l} today={today} />
                        <div className="hz-small hz-muted hz-row-wrap" style={{ gap: 6 }}>
                            <LeadValue lead={l} />
                            {l.days_in_stage !== null && l.days_in_stage !== undefined && <span>{daysInStageText(l.days_in_stage)}</span>}
                        </div>
                    </div>
                    <i className="ri-arrow-right-s-line hz-muted"></i>
                </Link>
            ))}
        </Card>
    );
}
